export default "__VITE_ASSET__DN85nVlY__"